module.exports = __webpack_public_path__ + "img/szhxNo.85ced87b.png";